import { Card } from "@osago/ui";
import { ReferralProvider } from "./model/referralContext";
import { ReferralSettingsPanel } from "./components/ReferralSettingsPanel";
import { HowItWorks } from "@/shared/ui/HowItWorks";
import { REFERRAL_STEPS } from "./components/referralSteps";
import { LinkOutput } from "./components/LinkOutput";
import { ReferralPreview } from "./components/ReferralPreview";
import { ParamsReference } from "./components/ParamsReference";

export function ReferralLinkBuilder() {
  return (
    <ReferralProvider>
      <div className="mx-auto grid max-w-350 gap-6 px-6 py-8 lg:grid-cols-[380px_1fr] lg:py-10">
        {/* Панель не sticky, в отличие от конструктора виджета: список СК у кита
            открывается только вниз, и на прилипшей панели его нижняя часть
            со скроллом оставалась за краем экрана. */}
        <Card as="aside" padding="lg" className="min-w-0 self-start">
          <ReferralSettingsPanel />
        </Card>
        <main className="flex min-w-0 flex-col gap-4">
          <HowItWorks steps={REFERRAL_STEPS} />
          <LinkOutput />
          <ReferralPreview />
          <ParamsReference />
        </main>
      </div>
    </ReferralProvider>
  );
}
